import { createBrowserHistory } from 'history'

export default process.env.IS_BROWSER && createBrowserHistory()

export const FIRST_PAGE = 'firstPage'

export const getLocationkey = location => {
  return location.key || FIRST_PAGE
}

export const getLocationPath = location => {
  return location.pathname + location.search + location.hash
}

export const getLocationNoHashPath = location => {
  return location.pathname + location.search
}

export enum HistoryStateKey {
  NEWS_LIST_STATE = 'NEWS_LIST_STATE',
  STACKED_STORE_PRODUCTS_STATE = 'STACKED_STORE_PRODUCTS_STATE',
}
